import React, { memo } from 'react'
import styles from './AdminDashboardCards.module.scss'
import { BpsAdminDashboardData } from '../../../../model/bps-admin/bps-admin-dashboard-data'

type Props = {
    data?: BpsAdminDashboardData
}

const AdminDashboardCards: React.FC<Props> = memo((props: Props) => {
    const { data } = props

    return (
        <div className={styles.cardsContainer}>
            <div className={`${styles.card} ${styles.registeredCustomersCard}`}>
                <div className={styles.cardHeader}>
                    Registered Customers
                </div>
                <div className={styles.cardBody}>
                    <div className={styles.cardBodyContent}>
                        {data?.registeredCustomers?.toLocaleString()}
                    </div>
                </div>
            </div>
            <div className={`${styles.card} ${styles.completedRepaymentsCard}`}>
                <div className={styles.cardHeader}>
                    Completed Repayments
                </div>
                <div className={styles.cardBody}>
                    <div className={styles.cardBodyContent}>
                        {data?.completedRepayments?.toLocaleString()}
                    </div>
                </div>
            </div>
            <div className={`${styles.card} ${styles.totalAmountRepaidCard}`}>
                <div className={styles.cardHeader}>
                    Total Amount Repaid
                </div>
                <div className={styles.cardBody}>
                    <div className={styles.cardBodyContent}>
                        {data?.totalAmountRepaid?.toLocaleString()}
                    </div>
                </div>
            </div>
            <div className={`${styles.card} ${styles.totalAmountOutstandingCard}`}>
                <div className={styles.cardHeader}>
                Total Amount Outstanding
                </div>
                <div className={styles.cardBody}>
                    <div className={styles.cardBodyContent}>
                        {data?.totalAmountOutstanding?.toLocaleString()}
                    </div>
                </div>
            </div>
            <div className={`${styles.card} ${styles.numberOfSolarProvidersCard}`}>
                <div className={styles.cardHeader}>
                Number of Solar Provider
                </div>
                <div className={styles.cardBody}>
                    <div className={styles.cardBodyContent}>
                        {data?.numberOfSolarProviders?.toLocaleString()}
                    </div>
                </div>
            </div>
        </div>
    )
})

export default AdminDashboardCards